// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "img[data-v-9484c5f0]{-o-object-fit:contain;object-fit:contain}", ""]);
// Exports
module.exports = exports;
